import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { medicineApi } from 'src/api/medicine';
import { GetMedicineDto } from 'woofwoof-api';

/**
 * The registry product the form is describing, and the lookup that hydrates it
 * from a saved medication.
 *
 * Owned by the modal rather than by the step that picks it: the leaflet is
 * shown on every step, and editing lets a vet jump straight to the dose without
 * the picker ever mounting.
 */
export function useSelectedMedicine(
  productId: string | undefined,
  enabled: boolean,
) {
  const [selectedMedicine, setSelectedMedicine] =
    useState<GetMedicineDto | null>(null);

  useQuery(
    ['medicine', productId],
    async () => {
      if (!productId) return null;
      return medicineApi.medicineControllerGetMedicineById({ id: productId });
    },
    {
      enabled: enabled && !!productId,
      select: (response) => response?.data,
      onSuccess: (data) => {
        if (data) setSelectedMedicine(data);
      },
    },
  );

  return { selectedMedicine, setSelectedMedicine };
}
